/**
 * React Query mutation hook for deleting ShowNotes blocks
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import httpClient from 'src/utilities/http-client'

/**
 * Delete a block via API
 */
async function deleteBlock(blockID: string, basePath: string): Promise<void> {
  await httpClient.delete(`/api/${basePath}/blocks/${blockID}`)
}

/**
 * Hook to delete a show notes block
 * Invalidates the blocks cache to refetch with resequenced remaining blocks
 */
export function useDeleteBlock(showNotesID: string, basePath: string) {
  let queryClient = useQueryClient()

  return useMutation({
    mutationFn: (blockID: string) => deleteBlock(blockID, basePath),
    onSuccess: () => {
      // Refetch to get resequenced blocks after deletion
      queryClient.invalidateQueries({
        queryKey: ['showNotesBlocks', basePath, showNotesID],
      })
    },
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to delete block:', error)
    },
  })
}
